<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div v-if="isLoading"><Loader /></div>
        <insurances-table
          :insurances="insurances"
          :refresh="fetchData"
          :searchQuery="searchTerm"
          v-else
        />
      </div>
    </div>
  </div>
</template>

<script>
import InsurancesTable from "./components/InsuranceTable.vue";
import Loader from "./components/Loader.vue";
import { fetchInsurances } from "../api/services/services";
import { ref } from "vue";

const isLoading = ref(false);
const insurances = ref([]);
const searchTerm = ref("");

export default {
  name: "Insurances",
  components: {
    InsurancesTable,
    Loader,
  },
  setup() {
    const fetchData = async (search, page) => {
      const entity_params = ref();
      entity_params.value = { search_query: search };

      isLoading.value = true;
      try {
        const response = await fetchInsurances(entity_params, page);
        insurances.value = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false;
      }
    };

    return {
      fetchData,
      insurances,
      isLoading,
      searchTerm,
    };
  },
  mounted() {
    this.fetchData("", 1);
  },
};
</script>
